import { useEffect, useState } from "react";

import List from "./List";
import Details from "./Details";

import * as _service from "../../service/customer.service";

const Customer = () => {
  const limit = 100;
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [modalData, setModalData] = useState({ show: false });

  useEffect(() => {
    handleTableData(1);
    setPage(1);
  }, [search]); // eslint-disable-line

  const handleTableData = async (currentPage = page) => {
    try {
      const response = await _service.list({ page: currentPage, limit, search });

      const { data, count } = response;
      setData(data);
      setTotalCount(count);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (value) => {
    setPage(value);
    handleTableData(value);
  };

  const handleToggle = ({ show = false, id } = {}) => {
    setModalData({ show, id });
    if (!show) handleTableData();
  };

  return (
    <>
      <h5 className="page-title">Customer</h5>
      <List
        data={data}
        onView={handleToggle}
        page={page}
        limit={limit}
        count={totalCount}
        onPageChange={handlePageChange}
        searchValue={search}
        onSearch={(value) => setSearch(value)}
      />
      <Details {...modalData} isOpen={modalData.show} onToggle={() => handleToggle()} />
    </>
  );
};

export default Customer;
